import React, { useState, useEffect, useRef } from 'react';
import CommonModal from './CommonModal';
import { useNavigate } from "react-router-dom";
import '../../styles/ValidatePinModal.css';

const PIN_LENGTH = 4;

const ValidatePinModal = ({ isOpen, onCancel, onConfirm, allowClose = true, title = 'Validate PIN', subtitle = 'Enter your 4-digit PIN to continue' }) => {
  const [digits, setDigits] = useState(Array(PIN_LENGTH).fill(''));
  const navigate = useNavigate();
  const inputRefs = useRef([]);

  useEffect(() => {
    if (isOpen) {
      setDigits(Array(PIN_LENGTH).fill(''));
      setTimeout(() => inputRefs.current[0]?.focus(), 50);
    }
  }, [isOpen]);

  const submit = (pin) => {
    if (pin.length === PIN_LENGTH) onConfirm(pin);
  };

  const handleChange = (index, rawValue) => {
    const value = rawValue.replace(/\D/g, '').slice(-1);
    const next = [...digits];
    next[index] = value;
    setDigits(next);

    if (value && index < PIN_LENGTH - 1) {
      inputRefs.current[index + 1]?.focus();
    }
    if (value && index === PIN_LENGTH - 1) {
      submit(next.join(''));
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !digits[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
    if (e.key === 'Enter') {
      submit(digits.join(''));
    }
  };

  const handlePaste = (e) => {
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, PIN_LENGTH);
    if (!pasted) return;
    e.preventDefault();
    const next = Array(PIN_LENGTH).fill('');
    pasted.split('').forEach((char, i) => { next[i] = char; });
    setDigits(next);
    if (pasted.length === PIN_LENGTH) {
      submit(pasted);
    } else {
      inputRefs.current[pasted.length]?.focus();
    }
  };

  return (
    <CommonModal isOpen={isOpen} onClose={onCancel} elId="validatePinModal" backdropClassName="pinModalBackdrop">
      <div className="pinModalBody">
        <div className="pinModalIcon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 10-8 0v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        {allowClose && (
          <button type="button" className="pinModalClose" onClick={onCancel} aria-label="Close">&times;</button>
        )}

        <h1 className="pinModalTitle">{title}</h1>
        <p className="pinModalSubtitle">{subtitle}</p>

        <div className="pinDigitsRow" onPaste={handlePaste}>
          {digits.map((digit, index) => (
            <input
              key={index}
              ref={(el) => (inputRefs.current[index] = el)}
              type="password"
              inputMode="numeric"
              maxLength={1}
              className="pinDigitBox" data-no-scan="true"
              value={digit}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
            />
          ))}
        </div>

        <button className="pinValidateBtn" onClick={() => submit(digits.join(''))}>
          Validate
        </button>

        {allowClose ? (
          <button className="pinBackLink" onClick={onCancel}>Close</button>
        ) : (
          <button className="pinBackLink" onClick={() => navigate("/dashboard")}>Back to Dashboard</button>
        )}
      </div>
    </CommonModal>
  );
};

export default ValidatePinModal;
